import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { FilterChangedEvent, IFloatingFilterParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
// noinspection ES6PreferShortImport
import { BooleanConvertionService } from '../../services/boolean-convertion.service';


@Component({
  selector: 'pt-boolean-adverb-filter-component',
  template: `
    <div class="ag-floating-filter-body" role="presentation">
      <div class="ag-floating-filter-input" role="presentation">
        <div role="presentation" class="ag-labeled ag-label-align-left ag-text-field ag-input-field ag-disabled"
             disabled="">
          <div class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation"
               (click)="onInputClick()">
            <input
              style="cursor: pointer!important"
              class="ag-input-field-input ag-text-field-input"
              type="text"
              disabled=""
              [ngModel]="this.currentValue | async"
            >
          </div>
        </div>
      </div>
    </div>
  `
})
export class BooleanToAdverbFilterComponent implements AgFloatingFilterComponent {
  params: IFloatingFilterParams;
  currentValue: Observable<boolean | string> = null;

  constructor(private booleanConvertionService: BooleanConvertionService) {
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
    if (parentModel?.values) {
      this.currentValue = this.booleanConvertionService.toAdverb(parentModel.values[0]);
    } else {
      this.currentValue = null;
    }
  }

  onInputClick() {
    this.params.showParentFilter();
  }
}
